import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-1 flex flex-wrap justify-between" }
const _hoisted_2 = { class: "lg:w-1/2 w-full" }
const _hoisted_3 = { class: "lg:w-1/2 w-full text-right" }

import FullButton from '@/components/Buttons/FullButton.vue'
    import TextButton from '@/components/Buttons/TextButton.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'TheOfferNavigation',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TextButton, {
      title: "Offerten",
      link: "/offers",
      id: "offers-subnavigationTitle"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(FullButton, {
          title: "Erweiterte Suche",
          link: "/offers/search/0",
          width: "95",
          colour: "red",
          id: "offers-subnavigationButton1"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(FullButton, {
          title: "nanoo.pro Cloud Services",
          link: "#",
          width: "95",
          colour: "blue",
          id: "offers-subnavigationButton2"
        })
      ])
    ])
  ], 64))
}
}

})